import { PAYMENT_VIEWS } from '@pages/Checkout/constants'
import { getCountryLabel } from '@pages/Checkout/helpers/billing'
import { useCheckoutContext } from '@pages/Checkout/routes/contexts'
import { Button, Heading, Loader, Panel, Spacer } from '@ui-kit'
import { useTranslation } from 'react-i18next'
import { Row } from 'simple-flexbox'

import { Details } from './components/Details'
import { Form } from './components/Form'

const { DETAILS, FORM } = PAYMENT_VIEWS

export const Billing = () => {
  const { t } = useTranslation()

  const {
    countriesList,
    customerResourceData,
    billingInformationIsLoading,
    formik,
    customerDataView,
    setCustomerDataView
  } = useCheckoutContext()

  const countryLabel = getCountryLabel({
    countries: countriesList,
    country: customerResourceData.country
  })

  const views = {
    [DETAILS]: (
      <Details
        customerResourceData={customerResourceData}
        countryLabel={countryLabel}
      />
    ),
    [FORM]: <Form formik={formik} countriesList={countriesList} />
  }

  return (
    <Panel border='neutral-2' surface={0} padding={30}>
      <Row vertical='center' horizontal='space-between'>
        <Heading level={3} weight={600}>
          {t('registration.flow.credit.card.step.billing.informations')}
        </Heading>

        {customerDataView === DETAILS ? (
          <Button
            variant='text-primary'
            size={12}
            onClick={() => {
              setCustomerDataView(FORM)
            }}
          >
            {t('word.edit')}
          </Button>
        ) : null}
      </Row>

      <Spacer space={20} />

      {billingInformationIsLoading || !customerDataView ? (
        <Loader />
      ) : (
        views[customerDataView]
      )}
    </Panel>
  )
}

Billing.displayName = 'CheckoutPaymentBilling'
